export const GET_ORDER_RECEPT = 'GET_ORDER_RECEPT';
export const GET_ORDER_RECEPT_SUCCESS = 'GET_ORDER_RECEPT_SUCCESS';
export const GET_ORDER_RECEPT_ERROR = 'GET_ORDER_RECEPT_ERROR';
export const GET_DOWNLOAD_ORDERSRECEPT = 'GET_DOWNLOAD_ORDERSRECEPT';
export const GET_DOWNLOAD_ORDERSRECEPT_SUCCESS = 'GET_DOWNLOAD_ORDERSRECEPT_SUCCESS';
export const GET_DOWNLOAD_ORDERSRECEPT_ERROR = 'GET_DOWNLOAD_ORDERSRECEPT_ERROR';
